import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { HasAccessDirective } from '@sharedModule/directives/has-access.directive';
import { MaterialModule } from '@sharedModule/material/material.module';
import { ColumnPipe } from '@sharedModule/pipe/column/column.pipe';
import { TRANSACTION_SETTINGS } from '../../constant/transaction-settings.constant';
import { MasterTransactionSettingTabsComponent } from '../master-transaction-setting-tabs/master-transaction-setting-tabs.component';
import { UpsertMasterTransactionSettingsComponent } from '../upsert-master-transaction-settings/upsert-master-transaction-settings.component';

@Component({
  selector: 'app-master-transaction-settings',
  standalone: true,
  imports: [
    ColumnPipe,
    CommonModule,
    MaterialModule,
    HasAccessDirective,
    MasterTransactionSettingTabsComponent,
  ],
  templateUrl: './master-transaction-settings.component.html',
  styleUrl: './master-transaction-settings.component.scss',
})
export class MasterTransactionSettingsComponent {
  public readonly tabs = TRANSACTION_SETTINGS;

  currentTabLabel: string = this.tabs[0].code;

  constructor(private dialogRef: MatDialog) {}

  onTabChange(event: MatTabChangeEvent): void {
    this.currentTabLabel = this.tabs[event.index].code;
  }

  addTransactionSettings(): void {
    this.dialogRef.open(UpsertMasterTransactionSettingsComponent, {
      disableClose: true,
      data: {
        action: 'Add',
        selectedTab: this.currentTabLabel,
      },
    });
  }
}
